module.exports = __webpack_public_path__ + "static/media/pickup.000a9db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pickup.png
// module id = 463
// module chunks = 0